import { CurrentDealAppointment } from "Types/state";

export function hasAppointment(appointment: CurrentDealAppointment | undefined | null) {
    return !!(appointment && appointment.date && appointment.time);
}
